module.exports = function(angularModule) {
  angularModule.factory('timePeriodService', function () {
    var millisPerSecond = 1000;
    var millisPerMinute = millisPerSecond * 60;
    var millisPerHour = millisPerMinute * 60;
    var millisPerDay = millisPerHour * 24;
    var millisPerMonth = millisPerDay * 30;

    var selectablePeriods = [
      { millis: millisPerHour,      display: "Hour",    url: "hour"    },
      { millis: millisPerHour * 6,  display: "6 Hours", url: "6-hour"  },
      { millis: millisPerDay,       display: "Day",     url: "day"     },
      { millis: millisPerDay * 3,   display: "3 Days",  url: "3-day"   },
      { millis: millisPerDay * 7,   display: "7 Days",  url: "7-day"   },
      { millis: millisPerDay * 30,  display: "Month",   url: "month"   },
    ];
    return {
      millis: {
        perSecond: millisPerSecond,
        perMinute: millisPerMinute,
        perHour: millisPerHour,
        perDay: millisPerDay,
        perMonth: millisPerMonth
      },
      selectablePeriods: selectablePeriods,
      periodForUrl: function (url, defaultPeriod = 'day') {
        var found = selectablePeriods.find((x) => x.url.toLowerCase() === url.toLowerCase());
        if (!found && url !== defaultPeriod) return this.periodForUrl(defaultPeriod, defaultPeriod);
        else return found;
      },
      periodToDateRange({ periodType, offset = 0 }) {
        var millis = this.periodForUrl(periodType).millis;
        var now = new Date();
        var start = new Date(now.getTime() - (millis * (offset + 1)));
        var end = new Date(now.getTime() - (millis * offset));
        return { start, end }
      }
    }
  });
}
